const DEFAULT_PREVIEW = {
  image:
    'https://d3to9p4w6lww5g.cloudfront.net/preview-sites/studio-preview.jpg',
  pageTitle: 'Ozone Studio',
  favicon: '/logo.jpeg',
  ogTitle: 'Ozone Studio Platform',
  ogDesc:
    'Build, design, and share web based virtual worlds like never before. Powered by Ozone platform. Multi blockchain interoperability built-in.',
};

const UNITY_PREVIEW = {
  image:
    'https://d3to9p4w6lww5g.cloudfront.net/preview-sites/studio-preview.jpg',
  pageTitle: 'Ozone Studio',
  favicon: '/logo.jpeg',
  ogTitle: 'Ozone Studio Platform',
  ogDesc:
    'Build, design, and share web based virtual worlds like never before. Powered by Ozone platform. Multi blockchain interoperability built-in.',
};

const ZEPETO_PREVIEW = {
  image:
    'https://d3to9p4w6lww5g.cloudfront.net/preview-sites/zepeto-preview.jpg',
  pageTitle: 'Zepeto Web Studio',
  favicon: 'https://cf-web.zepeto.me/favicon.png',
  ogTitle: 'ZEPETO WEB STUDIO',
  ogDesc:
    'A brand new way to build Zepeto worlds in the cloud powered by groundbreaking 3D technology and the new 3D Model Standard GLTF.  Build on the Web. Save as Unity. Deploy to Zepeto in minutes.',
};

const XSOLLA_PREVIEW = {
  image:
    'https://d3to9p4w6lww5g.cloudfront.net/preview-sites/xsolla-preview.svg',
  pageTitle: 'Xsolla Web Studio',
  favicon:
    'https://cdn.xsolla.net/strapi-bucket-prod/x_7bf715c4bd/x_7bf715c4bd.svg',
  ogTitle: 'XSOLLA WEB STUDIO',
  ogDesc:
    'Build, design, and share web based virtual worlds powered by Xsolla platform. Multi blockchain interoperability built-in.',
};

export const SITE_PREVIEW = {
  DEFAULT: DEFAULT_PREVIEW,
  ZEPETO: ZEPETO_PREVIEW,
  UNITY: UNITY_PREVIEW,
  XSOLLA: XSOLLA_PREVIEW,
};
